(() => {
  const ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"], form[action*="/cart/add"]';
  const BUTTON_SELECTOR = '.product-form__submit, button[name="add"], button[type="submit"]';

  let lastKnownCount = null;
  let activeForm = null;
  let activeButton = null;

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function getCart() {
    const response = await fetch(`${ROOT}cart.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('cart.js konnte nicht geladen werden');
    }

    return response.json();
  }

  function getVisibleButton() {
    const buttons = Array.from(document.querySelectorAll(BUTTON_SELECTOR));

    return buttons.find((button) => {
      const style = window.getComputedStyle(button);
      const rect = button.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0
      );
    }) || null;
  }

  function getButtonLabel(button) {
    if (!button) return null;

    return (
      button.querySelector('span') ||
      button.querySelector('.btn_text') ||
      button.querySelector('.button__text') ||
      button
    );
  }

  function setButtonState(button, state) {
    if (!button) return;

    const label = getButtonLabel(button);
    if (!label) return;

    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = label.textContent.trim();
    }

    button.classList.remove('is-adding', 'is-added');

    if (state === 'adding') {
      button.classList.add('is-adding');
      label.textContent = 'Wird hinzugefügt …';
      button.setAttribute('aria-busy', 'true');
    } else if (state === 'added') {
      button.classList.add('is-added');
      label.textContent = '✓ Im Warenkorb';
      button.removeAttribute('aria-busy');
    } else {
      label.textContent = button.dataset.originalLabel || 'In den Warenkorb';
      button.removeAttribute('aria-busy');
    }
  }

  function getActiveForm() {
    if (activeForm && document.body.contains(activeForm)) {
      return activeForm;
    }

    const visibleButton = activeButton && document.body.contains(activeButton)
      ? activeButton
      : getVisibleButton();

    if (visibleButton) {
      const form = visibleButton.closest('form');
      if (form) return form;
    }

    return document.querySelector(FORM_SELECTOR);
  }

  function ensureInlineMessage(form) {
    if (!form) return null;

    let note = form.querySelector('.cart-feedback-inline');

    if (!note) {
      note = document.createElement('div');
      note.className = 'cart-feedback-inline';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      note.hidden = true;
      note.innerHTML = `
        <span class="cart-feedback-inline__check">✓</span>
        <span class="cart-feedback-inline__text">Artikel wurde in den Warenkorb gelegt</span>
        <a class="cart-feedback-inline__link" href="${ROOT}cart">Zum Warenkorb</a>
      `;

      const button = form.querySelector(BUTTON_SELECTOR);
      if (button) {
        button.insertAdjacentElement('afterend', note);
      } else {
        form.appendChild(note);
      }
    }

    return note;
  }

  function showInlineMessage(form) {
    const note = ensureInlineMessage(form);
    if (!note) return;

    note.hidden = false;
    note.classList.add('is-visible');
  }

  function updateCartBubble(itemCount) {
    const bubbleRoot = document.querySelector('#cart-icon-bubble');
    if (!bubbleRoot) return;

    let bubble = bubbleRoot.querySelector('.cart-count-bubble');

    if (itemCount > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML =
          '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        bubbleRoot.appendChild(bubble);
      }

      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      const srText = bubble.querySelector('.visually-hidden');

      if (visibleCount) {
        visibleCount.textContent = itemCount > 99 ? '99+' : String(itemCount);
      }

      if (srText) {
        srText.textContent = `${itemCount} Artikel im Warenkorb`;
      }

      bubbleRoot.classList.remove('cart-feedback-bump');
      void bubbleRoot.offsetWidth;
      bubbleRoot.classList.add('cart-feedback-bump');
    } else if (bubble) {
      bubble.remove();
    }
  }

  async function waitForCartIncrease(previousCount) {
    for (let i = 0; i < 10; i++) {
      await delay(i === 0 ? 350 : 350);

      try {
        const cart = await getCart();
        const count = Number(cart.item_count || 0);

        if (count > previousCount) {
          lastKnownCount = count;
          return cart;
        }
      } catch (error) {
        console.error(error);
      }
    }

    return null;
  }

  async function finalizeSuccessFeedback() {
    let previousCount = lastKnownCount;

    if (previousCount === null) {
      try {
        const cart = await getCart();
        previousCount = Number(cart.item_count || 0);
        lastKnownCount = previousCount;
      } catch (error) {
        previousCount = 0;
      }
    }

    const updatedCart = await waitForCartIncrease(previousCount);

    if (!updatedCart) {
      const fallbackButton = activeButton || getVisibleButton();
      if (fallbackButton) {
        setButtonState(fallbackButton, 'default');
      }
      return;
    }

    const form = getActiveForm();
    const button = activeButton || getVisibleButton() || (form ? form.querySelector(BUTTON_SELECTOR) : null);

    updateCartBubble(Number(updatedCart.item_count || 0));

    if (button) {
      setButtonState(button, 'added');

      clearTimeout(button._resetTimer);
      button._resetTimer = setTimeout(() => {
        setButtonState(button, 'default');
      }, 1800);
    }

    if (form) {
      showInlineMessage(form);
    }
  }

  function rememberContextFromElement(element) {
    if (!element) return;

    const form = element.closest('form');
    if (form) activeForm = form;

    const button =
      element.matches(BUTTON_SELECTOR) ? element : element.closest(BUTTON_SELECTOR);

    if (button) activeButton = button;
  }

  document.addEventListener('click', (event) => {
    const clickedButton = event.target.closest(BUTTON_SELECTOR);
    if (!clickedButton) return;

    rememberContextFromElement(clickedButton);

    if (!clickedButton.disabled) {
      setButtonState(clickedButton, 'adding');
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    activeForm = form;
    activeButton = form.querySelector(BUTTON_SELECTOR);

    if (activeButton && !activeButton.disabled) {
      setButtonState(activeButton, 'adding');
    }

    finalizeSuccessFeedback().catch((error) => {
      console.error('Standard cart feedback error:', error);
      if (activeButton) setButtonState(activeButton, 'default');
    });
  }, true);

  window.addEventListener('pplrAddToCartCompleted', () => {
    const button = activeButton || getVisibleButton();
    if (button) {
      setButtonState(button, 'adding');
    }

    finalizeSuccessFeedback().catch((error) => {
      console.error('Zepto cart feedback error:', error);
      if (button) setButtonState(button, 'default');
    });
  });

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const cart = await getCart();
      lastKnownCount = Number(cart.item_count || 0);
      updateCartBubble(lastKnownCount);
    } catch (error) {
      console.error(error);
    }
  });
})();